import PropTypes from 'prop-types';
import { BsCheckCircle, BsClock, BsDashCircle, BsInfoCircle, BsXCircle } from 'react-icons/bs';

import Tooltip from '#globalComponents/Tooltip/Tooltip';
import TooltipPanel from '#globalComponents/Tooltip/TooltipPanel';

const StatusBadge = ({ status, errorMessage }) => {
	const getConfig = () => {
		switch (status) {
			case 'sent':
				return {
					text: 'Gesendet',
					icon: BsCheckCircle,
					className: 'bg-success-200 text-success-700 border-success-500/40',
				};
			case 'failed':
				return {
					text: 'Fehlgeschlagen',
					icon: BsXCircle,
					className: 'bg-warning-200 text-warning-700 border-warning-500/40',
				};
			case 'skipped':
				return {
					text: 'Übersprungen',
					icon: BsDashCircle,
					className: 'bg-bgBase-400 text-bgBase-800 border-bgBase-500',
				};
			case 'scheduled':
			case 'pending':
			default:
				return {
					text: 'Geplant',
					icon: BsClock,
					className: 'bg-caution-200 text-caution-700 border-caution-500/40',
				};
		}
	};

	const config = getConfig();
	const Icon = config.icon;
	// Both failed and skipped sends carry a reason in errorMessage — reveal it on hover.
	const hasError = (status === 'failed' || status === 'skipped') && Boolean(errorMessage);
	const tooltipLabel = status === 'skipped' ? 'Grund: ' : 'Fehler: ';
	const tooltipLabelClass = status === 'skipped' ? 'text-bgBase-800' : 'text-warning-700';

	if (!hasError) {
		return (
			<span
				className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${config.className}`}
			>
				<Icon className="h-3 w-3" />
				{config.text}
			</span>
		);
	}

	return (
		<Tooltip
			content={
				<TooltipPanel>
					<span className={`font-semibold ${tooltipLabelClass}`}>{tooltipLabel}</span>
					{errorMessage}
				</TooltipPanel>
			}
		>
			<span
				className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold cursor-help ${config.className}`}
			>
				<Icon className="h-3 w-3" />
				{config.text}
				<BsInfoCircle className="h-3.5 w-3.5" />
			</span>
		</Tooltip>
	);
};

StatusBadge.propTypes = {
	status: PropTypes.string.isRequired,
	errorMessage: PropTypes.string,
};

export default StatusBadge;
